import React from "react";
import { BrowserRouter, Redirect, Route } from "react-router-dom";
import { UnprotectedRouter } from "./unprotected";
import { ProtectedRouter } from "./protected";
import { useToken } from "contexts/UserContext";
import { APP_HOME, LANDING_SCREEN } from "./routePaths";
import { ErrorProvider } from "contexts/ErrorContext";

export const MainRouter = () => {
  setTimeout(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        "hiiiiiii from window.ReactNativeWebView"
      );
    }
    if (document.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        "hiiiiiii from document.ReactNativeWebView"
      );
    }
  }, 2000);

  const token = useToken();

  return (
    <BrowserRouter>
      <ErrorProvider>
        <Route exact path="/">
          {token ? (
            <Redirect to={APP_HOME} />
          ) : (
            <Redirect to={LANDING_SCREEN} />
          )}
        </Route>
        <ProtectedRouter />
        <UnprotectedRouter />
      </ErrorProvider>
    </BrowserRouter>
  );
};
